// Typeguards
export function isCharacterValidLootType(loot) {
    return loot.isFound;
}
export function isCharacterEnhancedItem(loot) {
    return isCharacterValidLootType(loot) && !(loot.equipmentCategory);
}
export function isEquippable(loot) {
    return isCharacterValidLootType(loot) && !isCharacterEnhancedItem(loot) && ['Weapon', 'Armor'].includes(loot.equipmentCategory);
}
export function isCharacterWeaponType(loot) {
    return isCharacterValidLootType(loot) && !isCharacterEnhancedItem(loot) && loot.equipmentCategory === 'Weapon';
}
export function isCharacterArmorType(loot) {
    return isCharacterValidLootType(loot) && !isCharacterEnhancedItem(loot) && loot.equipmentCategory === 'Armor';
}
export function isCharacterGearType(loot) {
    return isCharacterValidLootType(loot) && !isCharacterEnhancedItem(loot) && !['Weapon', 'Armor'].includes(loot.equipmentCategory);
}
